<script lang="ts" setup>
import type { StrapiPageError } from '@autobid/strapi-integration/typescript/strapi/Page'
import { useAuctionI18nSwitcher } from '@autobid/ui/composables/auction/useAuctionI18nSwitcher'
import { useBarometerCar } from '@autobid/ui/composables/car/data/useBarometerCar'
import { useAuctionId } from '@autobid/ui/composables/useAuctionId'
import { useAuctionValidator } from '@autobid/ui/composables/useAuctionValidator'
import { onServerPrefetch, provide } from 'vue'

const auctionId = useAuctionId()
await useAuctionValidator(auctionId.value)

const {
  data: car,
  isFetching,
  suspense,
} = useBarometerCar(
  { type: 'current', auctionId },
  {
    keepPreviousData: true,
  },
)

onServerPrefetch(suspense)
await suspense()

const { getAuctionPageLink } = useAuctionI18nSwitcher(auctionId.value)

provide('customI18nLinkFunction', getAuctionPageLink)

function handleError(error: StrapiPageError) {
  showError({
    statusCode: error.code,
    statusMessage: error.message,
  })
}
</script>

<template>
  <autobid-page
    key="auction-current"
    slug="auction-current"
    ignore-blacklist
    @error="handleError"
  >
    <template #default="{ pageData }">
      <Suspense v-if="pageData?.page">
        <template #default>
          <sections-auction-car-middleware v-if="car" :car="car.item.itemData">
            <CommonStrapiPage :page-data="pageData" />
          </sections-auction-car-middleware>
          <!-- render component immediatelly - the auction is already finished -->
          <CommonStrapiPage v-else-if="!isFetching" :page-data="pageData" />
        </template>

        <template #fallback>
          <div class="container mx-auto">
            <AutobidRenderComponents
              :components="pageData.components ?? []"
              fallback
            />
          </div>
        </template>
      </Suspense>
    </template>
  </autobid-page>
</template>
